import { useEffect, useState } from "react";
import GradePopup from "./RecommenderPage/GradePopup";

export function FinishedControlSurvey(props:{
    submittingGrade: boolean;
    gradePosted: boolean;
}) {
    const {submittingGrade, gradePosted} = props;
    const [showGradePopup, setShowGradePopup] = useState(false);
    useEffect(() => {
        if(gradePosted || submittingGrade) {
            setShowGradePopup(true);
        }
    }, [gradePosted, submittingGrade]); 
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            {!showGradePopup && <h1>Thank you for participating! You may now close this window.</h1>}
            {showGradePopup && <GradePopup onDismiss={() => setShowGradePopup(false)} submittingGrade={submittingGrade} />}
        </div>
    );
}